import React from 'react';
import { TableColumnConfig } from '@frontend/design-system';

type ResultType<T extends object> = string | ((data: T) => string | React.ReactNode);
export type ColumnOutput<T extends object> = {
  id: string;
  Header: string;
  accessor: ResultType<T>;
  cellRenderer?: (cellValue: any) => React.ReactNode;
};

export const getSmallViewTableColumns = <T extends object>(columns: TableColumnConfig<T>[]): ColumnOutput<T>[] => {
  return columns.map<ColumnOutput<T>>((column) => {
    return {
      accessor: column.accessor as ResultType<T>,
      cellRenderer: column.cellRenderer,
      id: column.id,
      Header: column.Header,
    } as ColumnOutput<T>;
  });
};
